import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { stringify } from "qs";

import { PUBLIC_ROOT, DATETIME_FORMAT } from "config/constants";
import Icon from "components/library/Icon";
import { readRevisionAsync } from "actions/items";
import { getNewsletterAsync } from "editor/actions/newsletter";

import phone from "assets/img/iphone.svg";
import styles from "./Preview.css";
import Spinner from "components/library/Spinner";
class Preview extends Component {
  constructor(props) {
    super(props);
    this.devicePicked = this._devicePicked.bind(this);
    this.frame = this._frame.bind(this);
    this.setLoading = this._setLoading.bind(this);
    this.state = {
      revDate: "Latest version",
      device: "desktop",
      loading: true,
    };
  }
  _setLoading() {
    this.setState({ ...this.state, loading: false });
  }
  _devicePicked(e) {
    this.setState({ device: e.target.value });
  }

  _frame(node) {
    if (this.state.device === "desktop") {
      return node;
    } else if (this.state.device === "mobile") {
      return (
        <div className={styles.mobileBg}>
          <div className={styles.phoneWrapper}>
            <div className={styles.phoneScreen}>{node}</div>
            <svg className={styles.phoneBezel} viewBox={phone.viewBox}>
              <use xlinkHref={`#${phone.id}`} />
            </svg>
          </div>
        </div>
      );
    }
  }
  UNSAFE_componentWillMount() {
    const {
      readRevisionAsync,
      match: {
        params: { id, revision, type },
      },
    } = this.props;
    if (id) {
      if (type === "newsletter") {
        this.props.getNewsletterAsync(id);
      }
      if (revision) {
        return readRevisionAsync(id, revision).then(({ payload }) => {
          if (payload.last_updated) {
            this.setState({
              revDate: moment(payload.last_updated).format(DATETIME_FORMAT),
            });
          }
        });
      }
    }
  }

  render() {
    let previewPath;
    const isNewsletter = this.props.match.params.type === "newsletter";
    const contentId = this.props.match.params.id;
    if (isNewsletter) {
      previewPath = `newsletters/${this.props.subscriptionSlug}-${contentId}`;
    } else {
      previewPath = `preview-${contentId}`;
    }
    const authedPreviewURL = `${PUBLIC_ROOT}/api/preview?${stringify({
      revision: this.props.match.params.revision,
      slug: previewPath,
      edenToken: this.props.accessToken,
    })}`;
    return (
      <div className={styles.root}>
        <main className={styles.body}>
          {this.state.loading && (
            <div className={styles.spinnerContainer}>
              <Spinner />
            </div>
          )}
          {this.frame(
            <iframe onLoad={this.setLoading} src={authedPreviewURL} />
          )}
        </main>
        <footer className={styles.footer}>
          <fieldset className={styles.devicePicker}>
            <label className={styles.pickerLabel}>
              <input
                type="radio"
                name="devicePicker"
                onChange={this.devicePicked}
                checked={this.state.device === "desktop"}
                value="desktop"
              />
              <span className={styles.pickerText}>
                <Icon name="desktop-preview" />
                Desktop
              </span>
            </label>
            <label className={styles.pickerLabel}>
              <input
                type="radio"
                name="devicePicker"
                onChange={this.devicePicked}
                checked={this.state.device === "mobile"}
                value="mobile"
              />
              <span className={styles.pickerText}>
                <Icon name="mobile-preview" />
                Mobile
              </span>
            </label>
          </fieldset>
          <span className={styles.date}>{this.state.revDate}</span>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  content: state.content,
  accessToken: state.token.accessToken,
  subscriptionSlug: state.editor.form.subscription.slug,
});

const mapDispatchToProps = {
  readRevisionAsync,
  getNewsletterAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);

Preview.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      revision: PropTypes.string,
      type: PropTypes.string,
    }),
  }),
  accessToken: PropTypes.string,
  readRevisionAsync: PropTypes.func,
  subscriptionSlug: PropTypes.string,
  getNewsletterAsync: PropTypes.func,
};
